import { render, staticRenderFns } from "./RegistrationView.vue?vue&type=template&id=325d2c4f&scoped=true&"
import script from "./RegistrationView.vue?vue&type=script&lang=js&"
export * from "./RegistrationView.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationView.vue?vue&type=style&index=0&id=325d2c4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325d2c4f",
  null
  
)

export default component.exports